exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-link .sidebar-link__text[data-v-1f693cae]{display:none;opacity:0}.sidebar-link.navbar-expanded[data-v-1f693cae]{width:320px}.sidebar-link.navbar-expanded .sidebar-link__text[data-v-1f693cae]{display:inline-block;opacity:1}.sidebar-link[data-v-1f693cae]:hover{width:320px;z-index:9999}.sidebar-link:hover .sidebar-link__text[data-v-1f693cae]{display:inline-block;opacity:1}.is-active[data-v-1f693cae]{background-color:#c7cae0}", ""]);

// exports
